import { Carousel } from "antd"
import axios from "axios"
import { useState } from "react"
import { useEffect } from "react"

const contentStyle = {
    height: "700px",
    objectFit: "fill"
  };

const HeroImage = () => {
    const [listOfGame, setListOfGame] = useState([])
    const games = async () => {
       const result = await axios.get("https://super-bootcamp-backend.sanbersy.com/api/games")
        .then((res)=> res.data)
        .catch((err) => {
            console.log(err)
        })
        const newListGame = result.slice(0,3)
        setListOfGame(newListGame)
    }

    useEffect(() => {
        games()
    }, [])

    return (
        <Carousel autoplay="true">
            {listOfGame.map((el)=>
                    <div key={el.id}>
                        <img style={contentStyle} src={el.image_url} alt="hero"></img>
                    </div>
            )} 
        </Carousel>
    )
}

export default HeroImage